export default {"src":"/_next/static/media/imageShadowSmall.268ac685.svg","height":6,"width":106};